import api from "./api";

export const stockService = {

  // 📦 CREATE STOCK
  createStock: async (stockData) => {
    try {
      const response = await api.post("/create-stock", stockData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📦 AVAILABLE STOCK (ADMIN)
  getAvailableStock: async () => {
    try {
      const response = await api.get("/available-bike");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📦 SHOWROOM STOCK
  getShowroomStock: async () => {
    try {
      const response = await api.get("/available-bike-showroom");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 🔄 STOCK TRANSFER
  transferStock: async (data) => {
    try {
      const response = await api.post("/stock-transfer", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 🔍 FILTER STOCK
  filterStock: async (params) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/filter-bikes?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 🔍 FIND BIKE BY ENGINE
  findBikeByEngine: async (engine) => {
    try {
      const response = await api.get(`/find-bike-details/${engine}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 🔍 FIND BIKE BY CHASIS
  findBikeByChasis: async (chasis) => {
    try {
      const response = await api.get(`/find-bike-detail/${chasis}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📊 ENTRY REPORT (DATE)
  getEntryByDate: async (date) => {
    try {
      const response = await api.get(`/find-entry-bike-details/${date}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📊 ENTRY WEEKLY
  getWeeklyEntry: async (year) => {
    try {
      const response = await api.get(`/find-entry-bike-weekly-details/${year}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📊 ENTRY MONTHLY
  getMonthlyEntry: async (year) => {
    try {
      const response = await api.get(`/find-entry-bike-monthly-details/${year}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📦 GET ALL MODELS + COLOUR
  getAllModels: async () => {
    try {
      const response = await api.get("/find-all-model-name-in-stock");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📍 MODEL LOCATION DISTRIBUTION
  getModelDistribution: async (model) => {
    try {
      const response = await api.get(
        `/find-no-of-bike-same-model-diff-place-in-stock/${model}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
    verifyPassword: async (type, password) => {
    try {
      const response = await api.post("/verify-password", { type, password });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
 
  // ✏️ UPDATE STOCK BIKE
  updateStock: async (stockData) => {
    try {
      const response = await api.put("/update-stock-bike", stockData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
 

 
};